export const censusTranslateKey: { [key: string]: string } = {
    Id: 'Numer rejestracji',
    InstructorId: 'Składający',
    RegisterYear: 'Rok rejestracji',
    RegistrationState: 'Stan rejestracji',
    Request: 'Złożony wniosek',
    VacationStartDate: 'Data rozpoczęcia urlopu',
    VacationEndDate: 'Data zakończenia urlopu',
    RegistrantComment: 'Twój komentarz',
    StateAwards: 'Odznaczenia państwowe i krzyże honorowe ZHR',
    YPSResidence: 'Oświadczenie - zamieszkiwanie',
    YPSCitizenship: 'Oświadczenie - obywatelstwo',
    YPSAccept: 'Akceptacja Standardów ochrony małoletnich',
    KRKIssueDate: 'Data wystawienia KRK',
    Acceptor: 'Akceptujący',
    Verifier: 'Weryfikujący',
    CreateDate: 'Data wysłania rejestracji',
};

export const summaryCensusTranslateKey: { [key: string]: string } = {
    comment: 'Twój komentarz',
    stateAwards: 'Odznaczenia państwowe i krzyże honorowe ZHR',
    ypsResidence: 'Oświadczenie - zamieszkiwanie',
    ypsCitizenship: 'Oświadczenie - obywatelstwo',
    ypsAccept: 'Akceptacja Standardów ochrony małoletnich',
    ypsKRKSent: 'Oświadczenie - dostarczenie KRK',
    krkIssueDate: 'Data wystawienia KRK',
};